<div class="servicio">
  <div class="intro">
    <div class="userData">
      <div class="welcome">
        <div class="info">
          <div class="titulo-servicios">
            <svg width="24" height="24"></svg>
            <h1>{{ esEdicion ? 'Actualizar vehículo' : 'Agregar vehículo' }}</h1>
          </div>
        </div>

        <input #fileInput type="file" accept="image/*" hidden (change)="mostrarImagen($event)" />

        <!-- Mostrar imagen -->
        <!--div *ngIf="imagenPreview" class="imagen-preview-contenedor">
          <div class="titulo-foto">📷 Fotografía agregada</div>
          <div class="imagen-preview">
            <img [src]="imagenPreview" alt="Preview vehículo" />
          </div>
        </div-->

        <!-- Botón de imagen -->
        <!--button class="vehiculo-photo-btn" (click)="seleccionarImagen()">
          {{ imagenPreview ? 'Agregar una nueva foto' : 'Agregar foto del vehículo (opcional)' }}
          <svg width="18" height="17"></svg>
        </button-->

        <!-- Marca -->
        <div class="text-field">
          <div class="content">
            <select
              [(ngModel)]="marca"
              name="marca"
              required
              (change)="cargarModelosPorMarca()"
            >
              <option value="" disabled selected>Marca</option>
              <option *ngFor="let item of marcas" [value]="item.descripcion">{{ item.descripcion }}</option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>





        <!-- Modelo -->
        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="modelo" name="modelo" required>
              <option value="" disabled>Modelo</option>
              <option *ngFor="let item of modelos" [value]="item.descripcion">
                {{ item.descripcion }}
              </option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <!-- Año -->
        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="anioSeleccionado" name="anio" required>
              <option value="" disabled selected>Año</option>
              <option *ngFor="let item of anios" [value]="item.id">{{ item.descripcion }}</option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <!-- Placa -->
        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Placa" [(ngModel)]="placa" name="placa" />
          </div>
        </div>

        <!-- Numero de Serie -->
        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Num. Serie" [(ngModel)]="serialNumber" name="Num. Serie" />
          </div>
        </div>

        <!-- Color-->
        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="color" name="color" required>
              <option value="" disabled [selected]="!color">
                Selecciona un color
              </option>
              <option *ngFor="let item of colores" [value]="item.descripcion.toLowerCase()">
                {{ item.descripcion }}
              </option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z"
                fill="#103A5A"
              />
            </svg>
          </div>
        </div>


        <!-- Blindado -->
        <div class="text-field">
          <div class="content">
            <label class="blindado-label">
              <input type="checkbox" [(ngModel)]="blindado" name="blindado" /> Vehículo blindado
            </label>
          </div>
        </div>

        <!-- Nivel de blindaje -->
        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="nivelBlindaje" name="nivelBlindaje" [disabled]="!blindado" required>
              <option value="" disabled>Blindaje</option>
              <option *ngFor="let item of nivelesBlindaje" [value]="item.id">
                {{ item.descripcion }}
              </option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <!-- Botón de envío -->
        <div class="button-row">
          <button (click)="enviarVehiculo()" class="vehiculo-submit">
            {{ esEdicion ? 'Actualizar vehículo' : 'Registrar vehículo' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
